import Phaser from 'phaser'
import {
    CST
} from '../CST'

export default class Credits extends Phaser.Scene {
    constructor() {
        super(CST.SCENES.CREDITS)
    }
    
    create(data) {
        this.clickSound = this.sound.add("click-sound");
        this.scene.bringToTop();
        this.bg = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'credits-bg');

        this.add.image(this.cameras.main.width / 2 - 685, (this.cameras.main.height / 2) + 355, 'previous-btn').setInteractive({
            useHandCursor: true
        }).on("pointerdown", () => {
            this.clickSound.play();
            this.scene.stop();
            this.scene.resume(data.scene, {data: 5});
        }).setScale(.4)
    }
}